/**
 * @fileoverview state manager for communication to the app, in this case
 * the app is the mastercard SRCi application popup window.
 * TODO: Retrofit this to talk to the DCF (will be same host anyways before launch)
 */

import Communicator from '../utils/communicator'

let communicator = null

const srciMessenger = {
  init,
  registerListeners
}

async function init (windowRef, host) {
  communicator = new Communicator(windowRef, host)
}

function registerListeners (listeners) {
  if (!listeners) throw new Error('nothing to register')

  listeners.forEach(listener => {
    const { name, handler } = listener
    communicator.registerHandler(name, handler)
  })
}

export default srciMessenger
